import { authAvatarThumbUrl } from './AuthStore';

export const updateAuthAvatarThumbUrl = (value) => authAvatarThumbUrl.update((oldValue) => value);
